import React, {Component} from 'react';
import styled from 'styled-components';
import {Button, FlexContainer, Text} from "../../design";
import {Col} from "react-awesome-styled-grid";


const Overlay = styled.div`
  position: absolute;
  min-width: 100vw;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  top: 0;
  left: 0;
`;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      eventId: null,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <Overlay>
          <FlexContainer
            flexDirection="column"
            justifyContent="center"
            alignContent="center"
            className="w-100"
          >
            <Col style={{width:"inherit"}} xs={8} sm={4} md={4} lg={6} xl={5}>
              <FlexContainer
                display="block"
                marginTop="5rem"
                borderRadius="10px"
                boxShadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                justifyContent="center"
                alignContent="center"
                paddingTop="3rem"
                paddingRight=".5rem"
                paddingBottom="3rem"
                paddingLeft=".5rem"
                backgroundColor="white"
                className="text-center"
              >
                <Text
                  fontSize="20px"
                  fontWeight="bold"
                  marginBottom="30px"
                  textAlign="center"
                  color="#ff1e1e"
                >
                  Oops!
                </Text>
                <Text
                  fontSize="14px"
                  fontWeight="bold"
                  textAlign="center"
                  color="#ff1e1e"
                >
                  Something went wrong and we are unable to serve you at this moment
                </Text>
                <br/>
                <Text
                  fontSize="14px"
                  textAlign="center"
                  color="#000000"
                >
                  We apologize for the inconvenience.
                </Text>
                <br/>
                <Button type="secondary"
                        border="2px solid #40A9FF !important"
                        color="#40A9FF !important"
                        paddingRight="1.5rem"
                        paddingTop=".4rem"
                        paddingBottom=".4rem"
                        borderRadius="50px"
                        paddingLeft="1.5rem"
                        onClick={() => window.history.back()}
                >
                  Go Back
                </Button>
              </FlexContainer>
            </Col>
          </FlexContainer>
        </Overlay>
      );
    }
    return children;
  }
}

export default ErrorBoundary;
